import React, { useMemo, useState, useEffect } from "react";
import ScrollList from "../other/scrollList";
import Checkbox from "./Checkbox";
import Button from "./Button";
import Input from "./Input";

export default function MultiSelectMenu({
  radio,
  closeState,
  setCloseState,
  hasSearch = true,
  items,
  setValue,
  getValues,
  name,
  watch,
  className,
  title,
  usesInForm,
  formName,
  shouldSubmitOnReset = true,
  ...props
}) {
  const applyButtonContent = "Применить";

  const [searchString, setSearchString] = useState("");

  const checkedBoxes = watch(name) || {};

  const handleOptionToggle = (optionName) => {
    const currentValues = getValues(name) || {};

    const newValues = radio ? {
      [optionName]: !currentValues[optionName],
    } : {
      ...currentValues,
      [optionName]: !currentValues[optionName],
    }

    setValue(
      name,
      newValues,
      { shouldValidate: true }
    );
  };

  const boxes = useMemo(() => {
    const boxes = items?.map((value, index) => {
      const isShowing = value.name
        .toLowerCase()
        .includes(searchString.toLocaleLowerCase());
      const showStyle = isShowing ? null : { display: "none" };
      const isChecked = !!checkedBoxes[value.id] || !!checkedBoxes[value.slug];
      return (
        <Checkbox
          style={showStyle}
          labelStyle={showStyle}
          label={value.name}
          key={value.id || value.slug || index}
          name={name}
          value={value.id || value.slug}
          id={name + "." + (value.id || value.slug)}
          checked={isChecked}
          onChange={() => handleOptionToggle(value.id || value.slug)}
        />
      );
    });

    return boxes;
  }, [items, searchString, checkedBoxes, watch]);

  function close() {
    setCloseState(true);
  }

  function apply() {
    setCloseState(true);
  }

  function reset() {
    setValue(name, {}, { shouldValidate: true });
  }

  const search = hasSearch ? (
    <Input
      placeholder="Поиск"
      value={searchString}
      onChange={(evt) => setSearchString(evt.target.value)}
      className='multiSelect-menu-search'
    />
  ) : null;

  return (
    <div
      className={`multiSelect-menu ${className ? `${className}` : ""}`}
      closed={"" + closeState}
      {...props}
    >
      <div className="multiSelect-menu-title">
        <p className="multiSelect-menu-title-text">{title}</p>
        <Button className="multiSelect-menu-title-closeButton" refStyle>
          <img src="/UI/closeIcon.svg" alt="Закрыть" onClick={close} />
        </Button>
      </div>

      {items?.length > 0 ? (
        <>
          {search}
          <ScrollList className="multiSelect-menu-scrollList">{boxes}</ScrollList>
          <div className="multiSelect-menu-buttons">
            <Button
              className="multiSelect-menu-button multiSelect-menu-button-reset"
              darkStyle
              type={shouldSubmitOnReset ? "submit": "button"}
              onClick={() => reset()}
            >
              Сбросить
            </Button>
            {!usesInForm && <Button
              className="multiSelect-menu-button multiSelect-menu-button-apply"
              contrastStyle
              type="submit"
              onClick={() => apply()}
            >
              {applyButtonContent}
            </Button>}
            {usesInForm && <Button
              className="multiSelect-menu-button multiSelect-menu-button-apply"
              contrastStyle
              type="button"
              onClick={() => apply()}
            >
              {applyButtonContent}
            </Button>}
          </div>
        </>

      ) : (
        <div className="multiSelect-menu-empty">
          <p className="multiSelect-menu-empty-text">Нет доступных вариантов для выбора</p>
        </div>
      )}

    </div>
  );
}
